import Vector from "victor";
import { Tool } from "@/wbcontroller/types/Tool";
import ToolType from "@/wbcontroller/types/ToolType";
import WhiteboardControllerInterface from "../types/WhiteboardControllerInterface";
import {
  SimplePointerEventHandler,
  SimplePointerEventHandlerDelegate,
} from "../SimplePointerEventHandler";

export default class PanTool
  implements Tool, SimplePointerEventHandlerDelegate
{
  toolType = ToolType.Pan;
  wb?: WhiteboardControllerInterface;
  eventHandler: SimplePointerEventHandler;
  isPointerDown = false;
  pointerDownViewportPoint = new Vector(0, 0);
  pointerDownCameraPoint = new Vector(0, 0);

  constructor() {
    this.eventHandler = new SimplePointerEventHandler(false);
  }

  settingsDidChange() {
    // do nothing
  }

  nextZIndexDidChange() {
    // do nothing
  }

  onPointerDown = (point: Vector) => {
    if (!this.wb) return;
    this.isPointerDown = true;
    this.pointerDownCameraPoint = this.wb.camera.origin.clone();
    this.pointerDownViewportPoint = point;
  };

  onPointerMove = (point: Vector) => {
    if (!this.wb) return;
    if (!this.isPointerDown) return;
    const diff = this.pointerDownViewportPoint.clone().subtract(point);
    this.wb.camera.setOrigin(
      this.pointerDownCameraPoint
        .clone()
        .add(diff.divide(this.wb.camera.scaleVector()))
    );
  };

  onPointerUp = () => {
    if (!this.wb) return;
    this.isPointerDown = false;
    this.wb.drawing.occlude();
  };

  abort() {
    this.onPointerUp(); // no difference
  }

  bind(wb: WhiteboardControllerInterface) {
    this.wb = wb;
    this.eventHandler.bind(wb, this);
  }

  // eslint-disable-next-line
  unbind(wb: WhiteboardControllerInterface) {
    this.wb = undefined;
    this.eventHandler.unbind();
  }
}
